import { Team, TeamIdentity } from '../types/index';

import { supabase } from './supabase';

export async function fetchAllTeams(): Promise<TeamIdentity[]> {
  const { data, error } = await supabase
    .from('teams')
    .select('*')
    .order('name');

  if (error) {
    throw new Error(`Failed to fetch teams: ${error.message}`);
  }

  if (!data) {
    return [];
  }

  return data.map((team: Team) => ({
    id: team.id,
    name: team.name,
  }));
}
